module.exports = __webpack_public_path__ + "static/media/green_down_arrow.c971d3dd.svg";